<div class="outdated-header">
	<h1 class="outdated-header-heading">{{ "settings.outdated_header_heading" | translate }}</h1>
	<span
		class="outdated-header-info"
		data-test="outdated-header-info"
		tabindex="0"
		(click)="openNewAppVersionDialog()"
		(keyup.enter)="openNewAppVersionDialog()"
		>{{ "settings.outdated_header_info" | translate }}</span
	>
</div>
